document.addEventListener('DOMContentLoaded', function(){
    const labelRemovalTargets = [
        '0.0',
        '0.0mm',
        '0.0 mm'
    ];

    let filterElement = document.querySelector('facet-filters-form');
    let filterElementMobile = document.querySelector('.mobile-facets__wrapper');

    if(!filterElement && !filterElementMobile) {
        return;
    }

    let labelsInFilterElement = Array.from(filterElement.querySelectorAll('.facet-checkbox__label'));
    let labelsInFilterElementMobile = Array.from(filterElementMobile.querySelectorAll('.facet-checkbox__label'));

    let labels = labelsInFilterElement.concat(labelsInFilterElementMobile);
    let labelsToRemove = [];

    labels.forEach((label, key) => {

        let labelToTest = label.textContent.trim().toString();

        if(labelRemovalTargets.includes(labelToTest)) {
            labelsToRemove.push(label);
        }
    });

    labelsToRemove.forEach((label, key) => {
        label.closest('.list-menu__item').remove();
    })
});
